<template>
  <main class="home">
    <div class="luab_bxos">
      <section class="section1">
        <el-carousel trigger="click" arrow="always">
          <el-carousel-item v-for="(item, index) in section1Arr" :key="index">
            <div @click="linkBanner(item.Link, item)" class="width100 h100 block hover">
              <!-- <video
                loop
                autoplay
                muted
                style="width: 100%; height: 100%; object-fit: cover"
                v-if="item.FileType == 2"
                :src="webUrl + item.ImgPath"
              ></video> -->

              <img :src="item.ImgPath" alt="" :onerror="bannerError" />
            </div>
          </el-carousel-item>
        </el-carousel>
      </section>
    </div>
    <div class="width1760 top-nav-list">
      <div class="left-nav-box">
        <div @click="handleOpenUrl(item.Link, item)" v-for="(item, index) in iconNavList"
          :style="{ backgroundImage: `url(${item.ImgPath})` }" :key="index" class="nav-item">
          <div class="nav-item-content">
            <div class="nav-item-content-title">
              {{ item.Title }}
            </div>
            <div class="nav-item-content-tips">
              {{ item.Body }}
            </div>
          </div>
        </div>
      </div>
      <div class="right-box">
        <div class="section-title">
          <span class="tit">报名通知</span>
          <a @click="toAll('/apipcEnroll')" class="right">
            <span style="margin-right: 10px">查看更多</span>
            <img class="right-icon" src="@/assets/img/17.png" alt="" />
          </a>
        </div>
        <div class="right notice-wrapper">
          <div class="notice-item" v-for="(item, index) in section2Arr" :key="index" @click="toDetail(item, 0)">
            <div class="notice-content">
              <p class="title">
                <span class="name">{{ item.Title }}</span>
              </p>
              <div class="time flex">
                报名起止日期：
                <div class="flex timebg">
                  <div style="margin-right: 14px" class="home10" />
                  <div>{{ item.EnrollTime }}</div>
                </div>
              </div>
            </div>
            <div class="home2" />
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="width1760">
      <div class="image-nav-list">
        <div v-for="(item, index) in columnList" :key="index" @click="gotoColum(item)" class="image-nav-item">
          <img class="image-nav-item-img" :src="item.ImgPath" />
        </div>
      </div>
    </div> -->
    <!-- <div v-if="section2Arr.length > 0" class="width1760">
      <div class="section-title">
        <span class="tit">报名通知</span>
        <a @click="toAll('/apipcEnroll')" class="right">
          <span style="margin-right: 10px">查看更多</span>
          <img class="right-icon" src="@/assets/img/17.png" alt="" />
        </a>
      </div>
      <section class="section2">
        <div class="left">
          <img :src="section2Arr[currentSection]?.ImgPath" alt="" @error="imgError" />
        </div>
        <div class="right notice-wrapper">
          <div class="notice-item" v-for="(item, index) in section2Arr" :key="index" @click="toDetail(item, 0)">
            <div @mouseenter="currentSection = index">
              <p class="title">
                <span class="juxing"></span>
                <span class="name">{{ item.Title }}</span>
              </p>
              <div class="time flex">
                报名起止日期：
                <div class="flex timebg">
                  <div style="margin-right: 14px" class="home10" />
                  <div>{{ item.EnrollTime }}</div>
                </div>
              </div>
            </div>
            <div class="home2" />
          </div>
        </div>
      </section>
    </div> -->

    <div v-for="(courseItem, courseIndex) in courseTypeList" :key="courseIndex" class="width1760">
      <div class="section-title">
        <div class="couse-type-header">
          <img v-if="courseItem.CourseType == '1'" class="section-icon" src="@/assets/img/type-icon-1.png" />
          <img v-else-if="courseItem.CourseType == '2'" class="section-icon" src="@/assets/img/type-icon-2.png" />
          <img v-else-if="courseItem.CourseType == '3'" class="section-icon" src="@/assets/img/type-icon-3.png" />
          <img v-else class="section-icon" src="@/assets/img/type-icon-1.png" />
          <span class="tit">{{ courseItem.CourseTypeName }}</span>
        </div>
        <a @click="toAll(`/course?CourseType=${courseItem.CourseType}`)" target="_blank" class="right">
          <span style="margin-right: 10px">查看更多</span>
          <img src="@/assets/img/17.png" class="right-icon" alt="" />
        </a>
      </div>
      <section class="section3">
        <div class="section-wrapper">
          <el-empty description="暂无课程" style="margin: auto;" :image="empty1" v-if="courseItem.listData?.length == 0" />
          <template v-else>
            <div class="section-item" v-for="(item, index) in courseItem.listData" :key="index"
              @click="toDetail(item, 1)">
              <div class="img">
                <img :src="item.ImgPath" alt="" />
              </div>
              <div class="content">
                {{ item.CourseName }}
              </div>
              <div class="flex mt20">
                <div class="type"># {{
                  item.ClassifyName }}</div>
                <div v-if="item.Price > 0" class="red">
                  ¥ <span class="amout">{{ item.Price }}</span>
                </div>
                <div v-else class="red"><span class="amout">免费</span></div>
              </div>
              <div class="flex">
                <div class="rate">
                  <span class="mr5">{{
                    parseFloat(item.StarNum).toFixed(1)
                    }}</span>
                  <el-rate v-model="item.StarNum" disabled text-color="#ff9900">
                  </el-rate>
                </div>
                <div class="user">
                  <img src="@/assets/img/home/4.png" alt="" />{{ item.StudyView }}
                </div>
              </div>
            </div>
          </template>
        </div>
      </section>
    </div>
    <div class="questionBank">
      <div class="questionBank-item">
        <div class="section-title">
          <div class="couse-type-header">
            <img class="section-icon" src="@/assets/img/type-icon-d.png" />
            <span class="tit">资料下载</span>
          </div>
          <a @click="toAll('/material')" target="_blank" class="right">
            <span style="margin-right: 10px">查看更多</span>
            <img class="right-icon" src="@/assets/img/17.png" alt="" />
          </a>
        </div>
        <section class="section99">
          <div>
            <div v-for="(item, index) in section6Arr" :key="index" class="questionBank-wrapper"
              @click="toDetail(item, 2)">
              <div class="questionBank-top">
                <img v-if="item.FileExt == '.docx' || item.FileExt == '.doc'" src="@/assets/img/home/29.png" alt="" />
                <img v-if="item.FileExt == '.zip'" src="@/assets/img/home/30.png" alt="" />
                <img v-if="item.FileExt == '.ppt'" src="@/assets/img/home/31.png" alt="" />
                <img v-if="item.FileExt == '.rar'" src="@/assets/img/home/32.png" alt="" />
                <img v-if="item.FileExt == '.txt'" src="@/assets/img/home/33.png" alt="" />
                <img v-if="item.FileExt == '.7z'" src="@/assets/img/home/34.png" alt="" />
                <img v-if="item.FileExt == '.pdf'" src="@/assets/img/home/35.png" alt="" />
                <span class="name"> {{ item.MaterialName }}</span>
              </div>
              <div class="questionBank-bottom">
                <div># {{ item.ClassifyName }}</div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div class="questionBank-item">
        <div class="section-title">
          <div class="couse-type-header">
            <img class="section-icon" src="@/assets/img/type-icon-q.png" />
            <span class="tit">题库中心</span>
          </div>
          <a @click="toAll('/qbank')" target="_blank" class="right">
            <span style="margin-right: 10px">查看更多</span>
            <img class="right-icon" src="@/assets/img/17.png" alt="" />
          </a>
        </div>
        <section class="section99">
          <div>
            <div v-for="(item, index) in section7Arr" :key="index" class="questionBank-wrapper"
              @click="toDetail(item, 3)">
              <div class="questionBank-top">
                <img src="@/assets/img/home/9.png" alt="" class="tkimg" />
                <span class="name">{{ item.ExerciseName }}</span>
              </div>
              <div class="questionBank-bottom">
                <div># {{ item.ClassifyName }}</div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div class="container1">
      <div class="label-box">
        <div class="label">关于筑才学院</div>
      </div>
      <div class="content">
        {{ $store.state.siteInfo.AboutUs }}
      </div>
      <div class="info">
      </div>
      <el-button type="primary" @click="handleGotoAbout" class="detail-btn">
        查看详情
      </el-button>
    </div>
  </main>
</template>

<script>
/* eslint-disable */
import Swiper from "swiper";
import "swiper/css/swiper.css";
import Bus from "@/util/bus";
import { GetBanners, GetSiteInfo, Course_GetTypes, ClickBanners } from "@/api/common";
import {
  Course_GetList,
  Column_GetList,
  Enroll_GetList,
  Material_GetList,
  Exercise_GetList,
} from "@/api/home";
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  name: "Home",
  components: {
    vueSeamlessScroll,
  },
  data() {
    return {
      columnList: [],
      isShowActiveAccount: false,
      bannerError: 'this.src="' + require("@/assets/img/banner5.png") + '"',
      currentSection: 0,
      iconNavList: [],
      modalDetail: {},
      section1Arr: [],
      section2Arr: [],
      section3Arr: [],
      section4Arr: [],
      section5Arr: [],
      section6Arr: [],
      section7Arr: [],
      section6Index: 0,
      courseTypeList: [],
      navList: [
        {},
        {},
        {},
        {}
      ],
      section6Select: [
        {
          label: "最新发布",
          text: "new",
          value: 0,
        },
        {
          label: "热门推荐",
          text: "popular recommendations",
          value: 1,
        },
      ],
    };
  },
  mounted() {
    // this.getGetSiteInfo();
    this.getBanner();
    // this.getCourse_GetList();
    this.getIcon()
    this.getCourseType()
    this.getEnroll_GetList();
    this.getColumn_GetList()
    this.getMaterial_GetList();
    this.getExercise_GetList();
    if (this.$store.state.Token) {
      Bus.$on("scroll", (data) => {
        const id = `#section${data}`;
        document.getElementById("app").scrollTo({
          top: this.$el.querySelector(id).offsetTop - 100,
          behavior: "smooth",
        });
      });
    }
  },
  methods: {
    handleGotoAbout() {
      this.$router.push('/about')
    },
    handleOpenUrl(url, item) {
      ClickBanners({
        "DataID": item.DataID,
        "Title": item.Title,
        "Link": item.Link,
        "ImgPath": item.ImgPath,
        "Body": item.Body
      })
      if (url && url.includes('http')) {
        window.open(url)

      } else {
        this.$router.push(url)
      }
    },
    async getCourseType() {
      let listData = [

        {
          CourseType: "2",
          CourseTypeName: "限时轻课",
          iconPath: `/pc/src/assets/img/type-icon-2.png`
        },
        {
          CourseType: "1",
          CourseTypeName: "奶茶小课",
          iconPath: `/pc/src/assets/img/type-icon-1.png`

        },
        {
          CourseType: "3",
          CourseTypeName: "系统进阶课",
          iconPath: `/pc/src/assets/img/type-icon-3.png`
        }
      ]
      let promises = []
      for (let i = 0; i < listData.length; i++) {
        promises.push(this.getCourseList(listData[i], i))
      }
      let results = await Promise.all(promises)
      results.forEach((item, index) => {
        if (listData[index]) {
          listData[index].listData = JSON.parse(JSON.stringify(item))
        }
      })
      console.log('listData', listData)
      this.courseTypeList = listData
    },
    async getCourseList(item, index) {
      const that = this
      return new Promise(function (resolve) {
        Course_GetList({
          CourseType: item.CourseType,
          PageSize: 5,
          OrderBy: 3,
        }).then((res) => {
          resolve(res.data)

        })
      });
    },
    gotoColum(item) {
      this.$router.push({
        path: "/column",
        query: { ColumnID: item.ColumnID, columnTitle: item.ColumnName },
      });
    },
    toLink(url) {
      if (url) {
        window.open(url, "_blank");
      }
    },
    toAll(path) {
      this.$router.push(path);
    },
    toDetail(item, type) {
      //0 报名 1课程 2资料 3题库
      if (type == 0) {
        this.$router.push({
          path: "/apipcEnrollDetail",
          query: { SubjectID: item.SubjectID },
        });
      } else if (type == 1) {
        this.$router.push({
          path: "/courseDetail",
          query: { CourseID: item.CourseID },
        });
      } else if (type == 2) {
        this.$router.push({
          path: "/materialDetail",
          query: { MaterialID: item.MaterialID },
        });
      } else if (type == 3) {
        this.$router.push({
          path: "/qbankDetail",
          query: { ExerciseID: item.ExerciseID },
        });
      }
    },
    closePop() {
      this.isShowActiveAccount = false;
    },
    linkBanner(url, item) {
      ClickBanners({
        "DataID": item.DataID,
        "Title": item.Title,
        "Link": item.Link,
        "ImgPath": item.ImgPath,
        "Body": item.Body
      })
      if (url) {
        if (url.indexOf("http") < 0) {
          window.open("https://" + url, "_blank");
        } else {
          // window.open(url, "_blank");
        }
      }
    },
    // 获取banner
    getBanner() {
      GetBanners({ MarkID: 1 }).then((res) => {
        this.section1Arr = res.data;
      });
    },
    getIcon() {
      GetBanners({ MarkID: 3 }).then((res) => {
        this.iconNavList = res.data;
      });
    },
    // 获取站点信息
    // getGetSiteInfo() {
    //   GetSiteInfo().then((res) => {
    //     this.$store.state.siteInfo = res.data;
    //   });
    // },
    getColumn_GetList() {
      Column_GetList({}).then((res) => {
        this.columnList = res.data;
      });
    },
    //获取报名
    getEnroll_GetList() {
      Enroll_GetList({ PageSize: 4 }).then((res) => {
        this.section2Arr = res.data;
      });
    },
    //获取资料
    getMaterial_GetList() {
      Material_GetList({ PageSize: 5 }).then((res) => {
        this.section6Arr = res.data;
      });
    },
    //题库中心
    getExercise_GetList() {
      Exercise_GetList({ PageSize: 5 }).then((res) => {
        this.section7Arr = res.data;
      });
    },
    //获取课程
    getCourse_GetList() {
      Course_GetList({
        CourseType: 2,
        PageSize: 5,
        OrderBy: 3,
      }).then((res) => {
        this.section3Arr = res.data;
      });
      Course_GetList({
        CourseType: 1,
        PageSize: 5,
        OrderBy: 3,
      }).then((res) => {
        this.section4Arr = res.data;
      });
      Course_GetList({
        CourseType: 3,
        PageSize: 5,
        OrderBy: 3,
      }).then((res) => {
        this.section5Arr = res.data;
      });
    },
    // 获取资料
    getNewList() {
      this.section4Leftloading = true;
      const data = {
        OrderBy: this.section4Index,
      };
      this.$ajax.get("/Index/GetNewList", { params: data }).then(({ data }) => {
        this.section4LeftArr = data;
        this.section4Leftloading = false;
      });
    },
  },
};
</script>

<style>
.home .swiper-container-free-mode .swiper-wrapper {
  /* 默认是ease-out */
  -webkit-transition-timing-function: linear;
  -ms-transition-timing-function: linear;
  -moz-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
}
</style>
<style lang="scss" scoped>
.container1 {
  background: url("~@/assets/img/home/11.png") no-repeat;
  background-size: 100% auto;
  background-position: bottom;
  background-repeat: no-repeat;
  padding-top: 80px;
  padding-bottom: 80px;
  padding-left: 60px;

  .label-box {
    height: 60px;
    line-height: 60px;
    display: flex;
    align-items: center;

    .xian {
      margin-left: 10px;
      width: 6px;
      height: 6px;
      background: #999999;
      border-radius: 50%;
    }

    .label {
      font-size: 30px;
      font-weight: bold;
      color: #333333;
    }



    .tit {
      margin-left: 10px;
      margin-right: 100px;
      font-size: 26px;
      color: #333333;

    }


  }

  .detail-btn {
    border-radius: 40px;
    background-color: #1D79FF;
    border: none;
  }

  .content {
    margin-top: 50px;
    line-height: 36px;
    width: 930px;
    font-size: 18px;
    text-indent: 2em;
    color: #666666;
  }

  .info {
    width: 1200px;
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    /* 允许换行 */
    .info-item {
      width: 50%;
      font-size: 18px;
      color: #222222;
      line-height: 32px;
      padding-right: 20px;

      img {
        margin-right: 10px;
      }

      .link {
        cursor: pointer;
        font-weight: bold;
        color: #1d79ff;
      }
    }
  }
}

.home {
  .luab_bxos {
    // width: 1920px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }

  .width1760 {
    width: 1760px;
    margin: 0 auto;
  }

  .section-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 40px;

    .couse-type-header {
      display: flex;
      align-items: center;

    }

    .section-icon {
      width: 40px;
      height: 40px;
      margin-right: 15px;
    }

    .tit {
      font-size: 30px;
      font-weight: bold;
      color: #333333;
    }

    .right {
      font-size: 16px;
      color: #666666;
      cursor: pointer;
    }
  }
}

.section1 {
  overflow: hidden;
  width: 100%;
  height: 402px;

  img {
    height: 100%;
    width: 100%;
  }

  ::v-deep .el-carousel {
    height: 100%;

    .el-carousel__container {
      height: 100%;
    }

    .el-carousel__arrow {
      width: 28px;
      height: 60px;
      background: rgba($color: #000000, $alpha: 0.5);
      font-size: 17px;
      border-radius: 0;

      &.el-carousel__arrow--left {
        left: -2px;

        i {
          right: 20%;
        }
      }

      &.el-carousel__arrow--right {
        right: 0;

        i {
          left: 20%;
        }
      }

      i {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    .el-carousel__indicators {
      li {
        padding: 26px 5px;

        button {
          width: 60px;
          background-color: #000000;
          opacity: 0.05;
        }

        &.is-active {
          button {
            background-color: #fff;
            opacity: 1;
          }
        }
      }
    }
  }
}

.section2 {
  margin-top: 24px;
  width: 1760px;
  height: 370px;
  background: #ffffff;
  border-radius: 10px;
  display: flex;
  gap: 30px;
  padding: 16px;

  .left {
    width: 448px;
    height: 336px;
    background: #d2e8f3;
    border-radius: 10px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .right {
    flex: 1;
    font-weight: 400;
    font-size: 20px;
    color: #333333;


  }
}

.notice-item {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 24px 0 14px;
  border-top: 1px solid #e6e6e6;
  position: relative;

  .notice-content {
    flex: 1;
    width: 10px;
  }

  .home2 {
    width: 24px;
    height: 7px;
    margin-top: 10px;
    background: url("~@/assets/img/home/3.png") no-repeat;
    background-size: 100% 100%;
  }

  .home10 {
    width: 25px;
    height: 25px;
    background: url("~@/assets/img/home/10.png") no-repeat;
    background-size: 100% 100%;
  }

  &:first-child {
    border-top: none;
  }

  .title {
    display: flex;
    align-items: center;
    margin-bottom: 7px;

    .name {
      font-size: 20px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
      line-height: 1;
    }
  }

  .time {
    font-size: 18px;
    color: #999999;

    .timebg {
      margin-left: 10px;
      font-weight: bold;
      color: #1d9934;
      background: #ecf7ee;
      padding: 2px;
      padding-right: 10px;
      border-radius: 4px;
    }
  }

  &:hover {
    color: #1d79ff;

    .home2 {
      width: 24px;
      height: 7px;
      margin-top: 10px;
      background: url("~@/assets/img/home/2.png") no-repeat;
      background-size: 100% 100%;
    }

    .title {
      .name {
        border-bottom: 1px solid #1d79ff;
      }
    }

    .time {
      .timebg {
        margin-left: 10px;
        font-weight: bold;
        color: #1d79ff;
        background: #eff6ff;
        padding: 2px;
        padding-right: 10px;
        border-radius: 4px;

        .home10 {
          width: 25px;
          height: 25px;
          background: url("~@/assets/img/home/14.png") no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
}

.notice-item::after {
  position: absolute;
  content: "";
  width: 8px;
  height: 8px;
  display: block;
  background-color: #E6E6E6;
  left: -20px;
  top: 32px;
}

.notice-item:hover::after {
  background-color: #1d79ff;
}

.section3 {
  margin-top: 12px;
  width: 1760px;

  .section-wrapper {
    display: flex;
    gap: 15px;

    .section-item {
      cursor: pointer;
      width: 340px;
      height: 420px;
      padding: 15px;
      background: #ffffff;
      border-radius: 10px;

      &:hover {
        transform: scale(1.01);
      }

      .content {
        margin-top: 15px;
        font-size: 20px;
        height: 55px;
        color: #333333;
        display: -webkit-box;
        overflow: hidden;
        /* 超出的文本隐藏 */
        text-overflow: ellipsis;
        /* 溢出用省略号显示 */
        -webkit-box-orient: vertical;
        /* 垂直排列子元素 */
        -webkit-line-clamp: 2;
        /* 显示的行数 */
      }

      .img {
        width: 308px;
        height: 231px;
        border-radius: 6px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .flex {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .type-items {
          display: flex;
          align-items: center;
        }

        .type {
          font-size: 16px;
          color: #999999;
          margin-right: 8px;
        }

        .amout {
          font-size: 24px;
          font-weight: bold;
        }

        .red {
          font-size: 16px;
          color: #e12a14;
          font-weight: bold;
        }

        .user {
          display: flex;
          align-items: center;
          font-size: 18px;
          color: #666666;

          img {
            width: 12px;
            height: 17px;
            margin-right: 9px;
          }
        }

        .rate {
          display: flex;
          align-items: center;
          font-weight: bold;
          font-size: 20px;
          color: #e12a14;

          .el-rate {
            margin-top: -4px;
          }
        }
      }
    }
  }
}

.learing_boxs {
  .left {
    width: 100%;
    background: transparent;
    border: 0;

    .swiper_learn {
      padding: 0;

      .swiper-slide {
        width: calc((100% - 46px) / 3) !important;
        padding: 0;
        height: auto;
        box-shadow: none;

        .img {
          height: 205px;

          img {
            height: 100%;
            //object-fit: contain;
          }

          margin-bottom: 0;
        }
      }
    }
  }
}

.questionBank {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 1760px;
  margin: 20px auto;
  gap: 20px;

  .questionBank-item {
    width: 50%;

    .section99 {
      margin-top: 16px;
      padding: 6px 27px 15px 52px;
      height: 314px;
      background: #ffffff;
      border-radius: 10px;
      box-sizing: border-box;

      .questionBank-wrapper {
        cursor: pointer;
        padding: 19px 0 13px;
        border-top: 1px solid #e6e6e6;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;

        &:first-child {
          border-top: none;
        }

        .questionBank-top {
          font-size: 20px;
          color: #333333;
          display: flex;
          align-items: center;
          flex: 1;
          width: 1px;

          .name {
            display: block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          img {
            width: 23px;
            height: 23px;
            margin: 0 10px;
          }

          .tkimg {
            width: 26px;
            height: 26px;
            margin: 0 10px;
          }
        }

        .questionBank-bottom {
          display: flex;
          align-items: center;
          gap: 30px;
          font-size: 18px;
          line-height: 1;
          color: #999999;
        }

        &:hover {
          .questionBank-top {
            color: #1d79ff;

            .name {
              border-bottom: 1px solid #1d79ff;
            }
          }

          .juxing {
            background: #1d79ff;
          }
        }
      }

      .questionBank-wrapper::before {
        position: absolute;
        content: "";
        width: 8px;
        height: 8px;
        background: #E6E6E6;
        display: block;
        left: -14px;
        top: 28px;
      }

      .questionBank-wrapper:hover:before {
        background: #1D79FF;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.seamless-scroll-wrapper {
  width: 100%;
  /* 您想要的宽度 */
}

.scroll-container {
  width: 100%;
  /* 您想要的宽度 */
  overflow: hidden;
}

.seamless-scroll {
  width: 100%;
  /* 确保滚动区域的宽度 */
}

.no_ist {
  &::after {
    content: none;
  }
}

.top-nav-list {
  padding-top: 30px;
  display: flex;
  align-items: center;
  margin-bottom: -10px;

  .left-nav-box {
    display: flex;
    align-items: center;
    width: 870px;
    flex-wrap: wrap;
    margin-right: 20px;

    .nav-item {
      width: 430px;
      margin-right: 10px;
      height: 220px;
      border-radius: 10px 10px 10px 10px;
      margin-bottom: 10px;
      padding: 40px 26px 40px 30px;
      display: flex;
      align-items: center;
      background-repeat: no-repeat;
      background-size: cover;
      cursor: pointer;

      .nav-item-content {
        flex: 1;

        .nav-item-content-title {
          font-size: 24px;
          color: #333333;
          line-height: 26px;
          margin-bottom: 17px;
        }

        .nav-item-content-tips {
          font-size: 16px;
          color: #808C99;
          line-height: 26px;
          margin-bottom: 35px
        }

        .nav-item-content-btn {
          padding: 8px 22px;
          background: #E7D7FD;
          border-radius: 16px;
          font-size: 14px;
          color: #975AFF;
          line-height: 1;
          width: fit-content;
          cursor: pointer;
        }
      }

      .right-icon {
        width: 140px;
        height: 140px;
      }
    }

    .nav-item:nth-of-type(2n-2) {
      margin-right: 0;
    }

    .nav-item:nth-last-child(-n+2) {
      margin-bottom: 0;
    }
  }

  .right-box {
    width: 870px;
    height: 450px;
    background: #FFFFFF;
    border-radius: 10px 10px 10px 10px;
    padding: 30px 26px 0 58px;

    .section-title {
      margin-top: 0;
    }
  }
}

.image-nav-list {
  margin-top: 40px;
  display: flex;
  align-items: center;
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  .image-nav-item {
    height: 200px;
    width: 868px;
    cursor: pointer;
    margin-right: 24px;
    margin-bottom: 20px;

    .image-nav-item-img {
      height: 200px;
      width: 868px;
      objkect-fit: cover;
      border-radius: 10px;
    }
  }

  .image-nav-item:nth-of-type(2n-2) {
    margin-right: 0;
  }
}

.right-icon {
  width: 7px;
  height: 11px;
}
</style>
